import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";
import Home from "@/pages/Home";
import ErcanTransfer from "@/pages/ErcanTransfer";
import GirneTaksi from "@/pages/GirneTaksi";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <HelmetProvider>
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <div className="min-h-screen bg-[#08080A] text-[#F7F5F0] antialiased ff-sans">
                        <Navbar />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/ercan-transfer" element={<ErcanTransfer />} />
                            <Route path="/girne-taksi" element={<GirneTaksi />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                        <Footer />
                        <FloatingActions />
                        <Toaster position="top-center" theme="dark" />
                    </div>
                </BrowserRouter>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
